// is used as a dropdown

export function tree() {
    const toggler = document.querySelectorAll<HTMLElement>(".caret");

    if (toggler.length > 0) {
        toggler.forEach((tree) => {
            tree.addEventListener("click", function (e) {
                const target = e.target as HTMLElement;
                const nested = target.parentElement?.querySelector(".nested");

                if (nested) {
                    if (nested.classList.contains("active")) {
                        nested.classList.remove("active");
                        target.classList.remove("caret-down");
                    } else {
                        nested.classList.remove("close");
                        nested.classList.add("active");
                        target.classList.add("caret-down");
                    }
                }
            });
        });
    }

    // for cms dropdowns (sets correct icon: plus / minus)
    const cmsDropdowns = document.querySelectorAll<HTMLElement>(
        ".cmsmodul_akkordion",
    );
    if (cmsDropdowns) {
        cmsDropdowns.forEach((cmsDropDown) => {
            const slDetailsElement =
                cmsDropDown.querySelectorAll<HTMLElement>("sl-details");
            if (slDetailsElement) {
                slDetailsElement.forEach((detail) => {
                    const tab =
                        detail.querySelector<HTMLElement>('[slot="summary"]');
                    const icon = document.createElement("span");
                    icon.classList.add("dropdown-icon");
                    if (tab) {
                        tab.append(icon);
                    }
                });
            }
        });
    }
}
